import { isEmpty } from "lodash";
import {
  IAbsencesConfigurationFormValues,
  ICompanyConfigurationsRequest,
  ICompanyConfigurationsResponse,
  WAITING_FOR_APPROVAL_REQUESTS_REMINDER,
} from "src/Pages/Company/Absences/AbsencesConfiguration/AbsencesConfiguration.models";

export const transformCompanyConfigurationToFormValues = (
  companyConfigurationData: ICompanyConfigurationsResponse | undefined
): IAbsencesConfigurationFormValues => {
  if (isEmpty(companyConfigurationData)) {
    return {
      mainAbsenceType: null,
      waitingForApprovalRequestsReminder: false,
    };
  }

  const { mainAbsenceType, featuresConfigurations } = companyConfigurationData;

  return {
    mainAbsenceType: mainAbsenceType
      ? { id: mainAbsenceType.id, label: mainAbsenceType.name }
      : null,
    waitingForApprovalRequestsReminder:
      !!featuresConfigurations?.[WAITING_FOR_APPROVAL_REQUESTS_REMINDER]
        ?.wholeCompany,
  };
};

export const parseCompanyConfigurationToBackend = (
  formData: IAbsencesConfigurationFormValues
): ICompanyConfigurationsRequest => ({
  mainAbsenceTypeId: formData.mainAbsenceType?.id || null,
  featuresConfigurations: {
    [WAITING_FOR_APPROVAL_REQUESTS_REMINDER]: {
      wholeCompany: formData.waitingForApprovalRequestsReminder,
    },
  },
});
